module.exports = __webpack_public_path__ + "img/category-note.68f3a286.png";